import LeftPanel, { hideLeftPanel } from 'common/components/leftPanel'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { isComponentElement } from 'features/unifiedFlow/api/interfaces'
import { getExperimentBadgesState } from 'features/unifiedFlow/contentPage/helpers'
import { selectElementAndFetchCampaignData } from 'features/unifiedFlow/store/unifiedFlowSlice'

import ElementCard from '../../components/ElementCard'
import ExperimentTypeBadges from '../../components/ExperimentTypeBadges'
import { useContent } from '../../hooks'

const LeftSection = () => {
  const dispatch = useAppDispatch()
  const { content } = useContent()

  const selectedElementId = useAppSelector(
    (state) => state.unifiedFlow.selectedElementId
  )

  const personalizedAndOptimizedElements =
    content?.elements.filter(
      (element) =>
        !!element.campaign_id ||
        (isComponentElement(element) && !!element.personalization_id)
    ) ?? []

  // TODO: HH-4889 Add badges with proper data when we connect with the backend

  return (
    <LeftPanel onOutsideClick={() => dispatch(hideLeftPanel())}>
      {personalizedAndOptimizedElements.map((element) => {
        const { element_id, name, display_name, icon, status } = element
        const isElementDisabled = status === 'disabled'
        const badgesState = getExperimentBadgesState(element)

        return badgesState?.isPersonalizable || badgesState?.isOptimizable ? (
          <ElementCard
            className="mb-4"
            key={element_id}
            element={element}
            title={display_name || name}
            icon={icon}
            isRemoveOptionShown={false}
            isDisabled={isElementDisabled}
            isSelected={element_id === selectedElementId && !isElementDisabled}
            isConfigurable={false}
            hasElementActionsMenu={false}
            content={badgesState && <ExperimentTypeBadges {...badgesState} />}
            onClick={() =>
              !isElementDisabled &&
              dispatch(selectElementAndFetchCampaignData(element))
            }
          />
        ) : null
      })}
    </LeftPanel>
  )
}

export default LeftSection
